export const ProductCodeEnum = {
    eBiz : "U8",
    eBizi : "U9",
    Access: "JB",
    Signature: "JD"
}